import styled from '@emotion/styled';
import dynamic from 'next/dynamic';

const Trustpilot = dynamic(
  () => import('../TrustSeals').then(module => module.Trustpilot),
  { ssr: false },
);

const Wrapper = styled.div`
  position: relative;
  display: flex;
  height: 350px;
  padding: ${({ theme }) => theme.spacing['50']};
  z-index: 10;
`;

const TrustpilotWidget = styled(Trustpilot)`
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translateX(-50%);
`;

export { Wrapper, TrustpilotWidget };
